'use client';

import { FC } from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import HotdeskButton from './HotdeskButton';
import styles from './BuiltForOwnersSection.module.scss';
export interface BuiltForOwnersSectionProps {
  onListWorkspace: () => void;
}
const BuiltForOwnersSection: FC<BuiltForOwnersSectionProps> = ({
  onListWorkspace
}) => {
  const t = useTranslations('builtForOwners');
  return <section className={styles.section} data-sentry-component="BuiltForOwnersSection" data-sentry-source-file="BuiltForOwnersSection.tsx">
            <div className={styles.header}>
                <span className={styles.eyebrow}>{t('subtitle')}</span>
                <h2 className={styles.heading}>{t('title')}</h2>
                <p className={styles.description}>{t('description')}</p>
                <HotdeskButton variant="primary" size="lg" onClick={onListWorkspace} className={styles.cta} data-sentry-element="HotdeskButton" data-sentry-source-file="BuiltForOwnersSection.tsx">
                    {t('cta')}
                </HotdeskButton>
            </div>

            <div className={styles.dashboard}>
                <Image src="/assets/images/hotdesk-os.png" alt="Hotdesk owner dashboard" width={2558} height={708} className={styles.dashboardImage} sizes="(max-width: 768px) 100vw, 1280px" priority={false} data-sentry-element="Image" data-sentry-source-file="BuiltForOwnersSection.tsx" />
            </div>
        </section>;
};
export default BuiltForOwnersSection;